import { create } from 'zustand';

/**
 * Cross-pane state for the browse views (NOT the app store — that file is
 * owned by another slice). Lets TagPane / graph filters push a query into
 * the SearchPane even when it is not mounted yet.
 */
interface PaneState {
  /** Last query pushed into the search pane. */
  searchQuery: string;
  /** Bumps on every push so SearchPane reacts even to an identical query. */
  searchRev: number;
  setSearchQuery(q: string): void;
}

export const usePaneState = create<PaneState>((set) => ({
  searchQuery: '',
  searchRev: 0,
  setSearchQuery: (searchQuery) =>
    set((s) => ({ searchQuery, searchRev: s.searchRev + 1 })),
}));
